declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function initMetaPixel() {
  if (window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  window.fbq('init', '1472824471225158')
  window.fbq('track', 'PageView')
}

export function trackAddToCart(value: number = 6.39, currency: string = 'USD') {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Tantrum-Free After-School Evenings',
      content_type: 'product',
      value: value,
      currency: currency,
    })
  }
}
